export default __webpack_public_path__ + "static/media/naac.250def32.png";